<template>
  <div
    v-if="recommendedEnabled && scenarioConfig"
    class="section__articles-container"
    :class="`recommended_container--${props.placementId}`"
  >
    <div>
      <component class="h4" v-if="title && (recommendArticlesStore.getFilteredArticlesCount() > 0 || recommendArticlesStore.isLoading)" :is="headingElement">
        {{ title }}
      </component>
    </div>
    <div
      v-for="(article, index) in recommendArticlesStore.getOnlyFilteredArticles(0, recommendPage * props.articlesCount)"
      :key="`recommend_article_${article.id}`"
      class="article-wrapper"
    >
      <!-- Article -->
      <DefaultArticlesArticleCard
        :article="article"
        :data-index="index"
        :type="ArticleComponentType.RECOMMENDED"
        :hide-author="props.hideAuthor"
        :hide-magazine="props.hideMagazine"
        :show-magazine-name="props.showMagazineName"
      />
    </div>

    <!-- Loading recommend articles -->
    <div
      v-if="recommendArticlesStore.isLoading"
      v-for="item in props.articlesCount"
      :key="`recommend_skeleton_${item}`"
      class="article-wrapper"
    >
      <DefaultSkeletonsArticleCard
        :type="ArticleComponentType.RECOMMENDED"
      />
    </div>

    <!-- Next page -->
    <div
      v-if="recommendArticlesStore.limit && recommendArticlesStore.getFilteredArticlesCount() >= recommendArticlesStore.limit"
      class="button-more-container"
    >
      <DefaultArticlesButtonMore
        :label="$t('articles.button_more')"
        :disabled="recommendArticlesStore.isLoading"
        @click="recommendNextPage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {RecommendPlacementId} from "~/libs/constants/RecommendPlacementId";
import type {PropType} from "vue";
import ArticleComponentType from "~/libs/constants/ArticleComponentType";
import type RecommendArticleFilters from "~/libs/interfaces/RecommendArticleFilters";

const props = defineProps({
  title: {type: String, required: false},
  headingElement: {type: String, required: false, default: 'h3'},
  articlesCount:  {type: Number, required: false, default: 5},
  placementId: { type: String as PropType<RecommendPlacementId>, required: true },
  itemId: {type: String, required: false, default: 'default'},
  hideAuthor: {type: Boolean, required: false, default: true},
  hideMagazine: {type: Boolean, required: false, default: false},
  showMagazineName: {type: Boolean, required: false, default: true},
})

const route = useRoute()
const router = useRouter()

const config = useRuntimeConfig()
const recommendedEnabled = config.public.recombee?.enabled

const scenarioConfig = useRecombeeScenariosConfig().getScenarioConfigByPlacementId(props.placementId)

const pageQueryParam = scenarioConfig?.pageQueryParam || 'recommPage'
let recommendPage = ref(Number(route.query[pageQueryParam] || 1))
const recommFilters: RecommendArticleFilters = {
  placementId: props.placementId,
  itemId: props.itemId
}
const recommendArticlesStore = useRecommendArticlesStore(props.placementId, props.itemId)

const recommendNextPage = () => {
  recommendPage.value = recommendPage.value + 1
  router.push({
    query: {
      ...route.query,
      [pageQueryParam]: recommendPage.value
    }
  })
  fetchArticles()
}

const fetchArticles = () => {
  if (import.meta.client) {
    try {
      recommendArticlesStore.setLimit(recommendPage.value * props.articlesCount)
      recommendArticlesStore.fetchArticles(recommFilters)
    } catch (e) {
      // show error message?
    }
  }
}

if (scenarioConfig) {
  // INIT load
  if (import.meta.client) {
    fetchArticles()
  }
}
</script>
